import moment from 'moment';
import _ from 'lodash';
import { integrationsByCategory } from 'shared/core/constants/integrations';
export var formatBirthdayForRewards = function(dateString) {
    var date = moment(dateString, [
        'MM-DD-YYYY',
        'YYYY-MM-DD',
        'MM/DD/YYYY'
    ]);
    if (date.isValid()) {
        return date === null || date === void 0 ? void 0 : date.format('YYYY-MM-DD');
    }
    return '';
};
export var rewardsProgramEnabled = function(cart) {
    var _cart_order;
    var rewardAdapters = _.keys(integrationsByCategory.rewards);
    var consumerDispensaryIntegrations = ((_cart_order = cart.order) === null || _cart_order === void 0 ? void 0 : _cart_order.dispensary).consumerDispensaryIntegrations;
    return !!_.find(rewardAdapters, function(adapter) {
        var _consumerDispensaryIntegrations_adapter;
        return consumerDispensaryIntegrations === null || consumerDispensaryIntegrations === void 0 ? void 0 : (_consumerDispensaryIntegrations_adapter = consumerDispensaryIntegrations[adapter]) === null || _consumerDispensaryIntegrations_adapter === void 0 ? void 0 : _consumerDispensaryIntegrations_adapter.enabled;
    });
};
/**
 * Resolves whether an AIQ rewards operation may use a blank PIN.
 *
 * Flag-off callers get the legacy decision without consulting readiness. Under the new flag,
 * cached/SSR settings are never authoritative: only a matching completed network refresh may
 * resolve Manual vs Automatic. An absent setting still means Automatic, but only after that
 * authoritative refresh. Existing nonblank customer PINs remain safe to submit while settings
 * are unresolved because they cannot trigger a new SMS.
 */ export var getAiqSmsPinTriggerDecision = function(param) {
    var isAiqSmsPinTriggerSettingEnabled = param.isAiqSmsPinTriggerSettingEnabled, legacyShouldSkipSmsPin = param.legacyShouldSkipSmsPin, dispensaryId = param.dispensaryId, userId = param.userId, readiness = param.readiness, aiqSmsPinTriggerBehavior = param.aiqSmsPinTriggerBehavior, _param_userEnteredPin = param.userEnteredPin, userEnteredPin = _param_userEnteredPin === void 0 ? '' : _param_userEnteredPin;
    if (!isAiqSmsPinTriggerSettingEnabled) {
        return {
            isAuthoritative: true,
            shouldDeferBlankPinOperation: false,
            shouldSkipSmsPin: legacyShouldSkipSmsPin
        };
    }
    var isAuthoritative = (readiness === null || readiness === void 0 ? void 0 : readiness.status) === 'ready' && readiness.dispensaryId === dispensaryId && readiness.userId === (userId !== null && userId !== void 0 ? userId : null);
    var hasUserEnteredVerificationPin = !!userEnteredPin && userEnteredPin !== 'skip';
    return {
        isAuthoritative: isAuthoritative,
        shouldDeferBlankPinOperation: !isAuthoritative && !hasUserEnteredVerificationPin,
        shouldSkipSmsPin: isAuthoritative && aiqSmsPinTriggerBehavior === 'manual'
    };
};
